import { useRBAC } from '@/products/shared/utils/rbac';

/**
 * Custom hook for super admin functionality
 * Provides easy access to super admin status and related utilities
 */
export const useSuperAdmin = () => {
  const { role, isSuperAdmin, hasRole, loading } = useRBAC();

  return {
    /**
     * Whether the current user is a super admin
     */
    isSuperAdmin: isSuperAdmin(),
    
    /**
     * Whether the current user has super admin role specifically
     */
    hasSuperAdminRole: hasRole('super_admin'),
    
    /**
     * The current user's role
     */
    role,
    
    /**
     * Whether the RBAC system is still loading
     */
    loading,
    
    /**
     * Whether the current user can access super admin features
     * (same as isSuperAdmin, but more semantic)
     */
    canAccessSuperAdminFeatures: isSuperAdmin(),
  };
}; 